import AppShell from "./app/App";

function App() {
  return <AppShell />;
}

export default App;
